window.submitFormConfirmation = (formId, recordName, isChanged, messageText, okButtonText, cancelButtonText, dialogContentUrl) => {

    let itemViewModel = function( item ){
        let self = this;

        self.id = ko.observable(item.id);
        self.name = ko.observable(item.name);
        self.selected= ko.observable(false);
    }

    let dialogViewModel = function( items ){
        let self = this;

        self.modelIsReady = ko.observable(false);
        self.childrenEventItems = ko.observableArray( ko.utils.arrayMap(items, ( item ) => new itemViewModel(item)) );
        self.searchInputValue = ko.observable();
        self.searchValue = ko.observable();

        self.items = ko.computed(() => {
            if(!self.searchValue()) {
                return self.childrenEventItems();
            } else {
                var regex = new RegExp(self.searchValue(), "i");
                return ko.utils.arrayFilter(self.childrenEventItems(), (item) => {
                    return regex.test(item.name);
                });
            }
        })

        self.isChangeForEvents = ko.observable("1");
        self.isEventsApply = ko.observable(true);
        self.isItemsPresent = ko.computed(() => self.items().length > 0);

        self.searchGo = () => {
            self.searchValue(self.searchInputValue());
        };

        self.searchReset = () => {
            self.searchValue('');
            self.searchInputValue('');
        };

        self.prepareParameter = ( isConfirmed ) => {
            let childrenInfoField = document.getElementById('children_info');
            if ( isConfirmed ) {
                let selectedItems = []
                ko.utils.arrayForEach(self.childrenEventItems(), (item) => {
                    if (item.selected())
                        selectedItems.push(item.id());
                });

                if (selectedItems.length > 0) {
                    if (childrenInfoField !== null)
                        childrenInfoField.value = selectedItems.join(',');// + ":" + self.isChangeForEvents();
                }
            } else {
                if (childrenInfoField !== null)
                    childrenInfoField.value = null;
            }
            childrenInfoField.value +=  ":" + self.isChangeForEvents();
        }

        self.cancel = () => {
            let childrenInfoField = document.getElementById('children_info');
            if (childrenInfoField !== null)
                childrenInfoField.value = null;
        };
    }

    let eventUpdateConfirmationDialog = function() {
        const swalWithBootstrapButtons = Swal.mixin({
            position: 'center',
            reverseButtons: true,
            customClass: {
                confirmButton: 'btn btn-primary btn-lg action-btn',
                cancelButton: 'btn btn-default btn-lg action-btn',
                actions: "popup-actions-container",
                htmlContainer: "popup-html-container"
            },
            buttonsStyling: false
        })

        swalWithBootstrapButtons.fire({
            icon: 'warning',
            title: messageText,
            showCancelButton: true,
            confirmButtonText: okButtonText || "Save",
            cancelButtonText: cancelButtonText || "Cancel"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                $("form#" + formId).submit();
            }
        });
    }

    let templateUpdateConfirmationDialog = function( dialogContentUrl ){

        const options = {
            title: '',
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: okButtonText || "Save",
            cancelButtonText: cancelButtonText || "Cancel",
            customClass: {
                confirmButton: 'btn btn-primary btn-lg',
                cancelButton: 'btn btn-default btn-lg',
                actions: "save-template-popup-actions-container",
                htmlContainer: "popup-html-container-template"
            },
            buttonsStyling: false
        };

        const swalWithBootstrapButtons = Swal.mixin({
            position: 'center'
        });

        swalWithBootstrapButtons.fire({
            template: '#swal-save-dialog-template',
            title:  messageText,
            timerProgressBar: true,
            didOpen: (popup) => {
                Swal.showLoading();
                $.ajax({ url: dialogContentUrl,
                         method: "GET",
                         dataType: "json",
                         success: ( response ) => {
                             Swal.update( options );
                             popup.style.width = '700px'

                             window.saveFormConfirmationModel = new dialogViewModel( response );

                             ko.applyBindings(window.saveFormConfirmationModel, document.getElementById('save-dialog-content'))
                         },
                         error: (xhr, status, error) => {
                             Swal.close()
                             Swal.fire({
                                 icon: "error",
                                 title: "Oops...",
                                 text: "Something went wrong!"
                             });
                         },
                         complete: () => {
                             Swal.hideLoading();
                             window.saveFormConfirmationModel.modelIsReady(true);
                         }
                       });
            }
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            window.saveFormConfirmationModel.prepareParameter( result.isConfirmed );
            if (result.isConfirmed) {
                $("form#" + formId).submit();
            }
        });
    }

    if (isChanged) {
        if (recordName === 'fair') {
            eventUpdateConfirmationDialog();
        } else if (recordName === 'template') {
            templateUpdateConfirmationDialog( dialogContentUrl );
        }
    } else {
        $("form#" + formId).submit();
    }
};